import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

/** Where the free pre-planning guide lives. The one UTM says who sent
 * the reader; nothing else rides along. */
const PLANNING_GUIDE_URL =
  "https://form.typeform.com/to/gvTJ4PQX?utm_source=after_app";

/** The free planning guide, offered wherever a policy cannot be. */
export default function PlanningGuideCard({
  onClick,
}: {
  onClick?: () => void;
}) {
  return (
    <a
      href={PLANNING_GUIDE_URL}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      className="group flex items-start justify-between gap-4 rounded-2xl border border-oat-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md sm:p-6"
    >
      <div className="flex min-w-0 flex-col gap-1.5">
        <span className="text-[13px] font-bold uppercase tracking-[0.14em] text-oat-700">
          Free planning guide
        </span>
        <span className="font-serif text-[22px] leading-tight text-soil">
          Plan everything ahead, with or without a policy
        </span>
        <p className="text-base leading-[1.55] text-oat-700">
          Our pre-planning guide walks through the decisions, the real costs,
          and the questions families wish they&rsquo;d asked — free, no policy
          required.
        </p>
      </div>
      <ArrowTopRightOnSquareIcon
        className="mt-1 h-5 w-5 shrink-0 text-evergreen transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
        strokeWidth={2}
        aria-hidden="true"
      />
    </a>
  );
}
